@if (loading) {
  <div style="width: 100%;text-align: center;margin-top:75px;">
    <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
    <p>Načítání</p>
  </div>
}
@else {
  <div class="content">
    <button mat-button (click)="goToDashboard()"><mat-icon slot="start">arrow_back</mat-icon> Zpět</button>
    <div class="prg">
      <span>Průběh rozhovoru:</span>
      <mat-progress-bar mode="determinate" value="{{progress}}"></mat-progress-bar>
      <span>0%</span>
      <span style="float:right;">100%</span>
    </div>
    <div class="chat-content">
      <div class="chat-inner-content">
        @if ((agentText || agentSpeaking) && !firstbubble) {
          <div class="speech-bubble {{agentSpeaking && !thinking ? 'speech-bubble-active' : 'speech-bubble-inactive'}}">
            <p>
              {{agentText}}
              @if (agentSpeaking && !thinking) {
                <span class="typing-dots">
                <span>.</span><span>.</span><span>.</span>
              </span>
              }
            </p>
          </div>
        }
        <div class="img-agent">
          <div class="waveform-wrapper" style="{{agentSpeaking && !thinking ? 'border: 1px solid #fce0c8;' : 'border: 1px solid lightgray;'}}">
            <canvas
              style="{{!agentSpeaking || thinking ? 'visibility:hidden;' : 'visibility:visible;'}}"
              #waveformCanvas></canvas>
            @if (isFinished) {
              <div class="spinner-overlay">
                <p>Dotazník je kompletní, děkujeme.</p>
                <button mat-button (click)="goToDashboard()">Zpět do menu</button>
              </div>
            }
            @else {
              @if (thinking) {
                <span class="spinner-overlay" style="color: #ddd; margin-left: -80px;">Přemýšlím</span>
                @if (isSlow) {
                  <span class="spinner-overlay" style="margin-top: 50px">Trvá nám to déle než obvykle, zkoušíme to napravit.</span>
                }
                <div class="loader spinner-overlay"></div><br>
              }
              @if (!thinking && !agentSpeaking && !paused) {
                @if (pauseWarning) {
                  <span style="color: black;" class="spinner-overlay"><strong>Začněte mluvit</strong> <img style="vertical-align: middle;" src="assets/img/ico_ear.svg"></span>
                }
                @else {
                  @if (prefersText) {
                    <span style="color: #ddd;" class="spinner-overlay">
                      Uveďte prosím kompletní odpověď<br>
                      <small>Pro odeslání
                        @if (!isMobile) {
                           stiskněte Enter nebo
                        }
                        klikněte na šipku.</small>
                    </span>
                  }
                  @else {
                    <span style="color: #ddd;" class="spinner-overlay">Poslouchám <img style="vertical-align: middle;" src="assets/img/ico_ear.svg"></span>
                  }
                }
              }
              @if (paused && !thinking) {
                @if (userPaused && !transcriptFailed) {
                  <button (click)="unpauseInterview()" style="padding: 30px;" class="spinner-overlay restart" mat-button extended>
                    Rozhovor přerušen uživatelem.<br>
                    Klikněte pro zopakování odpovědi.
                    <mat-icon class="bigIcon" slot="end" iconPositionEnd>refresh</mat-icon>
                  </button>
                }
                @if (!userPaused && !transcriptFailed) {
                  <button (click)="unpauseInterview()" style="padding: 30px;" class="spinner-overlay restart" mat-button extended>
                    Rozhovor přerušen, nic neslyším.<br>
                    Klikněte pro zopakování odpovědi.
                    <mat-icon class="bigIcon" slot="end" iconPositionEnd>refresh</mat-icon>
                  </button>
                }
                @if (transcriptFailed) {
                  <button (click)="unpauseInterview()" style="padding: 30px;" class="spinner-overlay restart" mat-button extended>
                    Rozhovor přerušen, došlo k drobnému výpadku v komunikaci mezi servery. Prosím, chvíli vyčkejte, případně za moment stránku znovu aktualizujte.<br>
                    Klikněte pro zopakování odpovědi.
                    <mat-icon class="bigIcon" slot="end" iconPositionEnd>refresh</mat-icon>
                  </button>
                }
              }
            }
          </div>
        </div>
        <div class="chat-content">
          @if (respText || (!agentSpeaking && !thinking)) {
            @if (prefersText && !agentSpeaking && !thinking) {
              <div class="speech-bubble {{agentSpeaking || thinking || paused ? 'speech-bubble-inactive' : 'speech-bubble-active'}}"
                style="display: flex; align-items: center; justify-content: center;">
                <textarea (input)="onKeyboardInput()" id="textInput" matInput [disabled]="agentSpeaking || thinking || paused"
                  [autofocus]="true" style="min-width: 80%; min-height: 110px; max-width: 90%;"
                  [(ngModel)]="respText" (keyup.enter)="stopTyping()"></textarea>
                <button [disabled]="agentSpeaking || thinking || paused || !respText" mat-button (click)="stopTyping()" color="success">
                  <mat-icon>send</mat-icon>
                </button>
              </div>
            }
            @else {
              <div class="speech-bubble {{agentSpeaking || thinking || paused ? 'speech-bubble-inactive' : 'speech-bubble-active'}}">
                <p>
                  {{respText}}
                  @if (!agentSpeaking && !thinking && !paused) {
                    <span class="typing-dots">
                    <span>.</span><span>.</span><span>.</span>
                  </span>
                  }
                </p>
              </div>
            }
          }
        </div>
        <div class="controls">
          <button mat-fab color="primary" class="btnMic" disableRipple (click)="btnMicClick()" [disabled]="agentSpeaking || paused" class="{{agentSpeaking || paused ? '' : 'pulsate'}}">

              @if (agentSpeaking) {
                @if (prefersText) { <ng-container><mat-icon>keyboard_lock_off</mat-icon></ng-container> }
                @else { <ng-container><mat-icon>mic_off</mat-icon></ng-container> }
              } @else {
                @if (prefersText) { <ng-container><mat-icon>keyboard</mat-icon></ng-container> }
                @else { <ng-container><mat-icon>mic</mat-icon></ng-container> }
              }
          </button><br>
          <p>
            <strong>{{instructions}}</strong>
          </p>
          @if (!loading) {
            <div class="pauseDiv">
              <p [style.visibility]="timeForPause ? 'visible' : 'hidden'" class="pauseText"><strong>Jste unaveni?</strong><br>Nyní je vhodná chvíle pro přerušení rozhovoru.</p>
              <button class="btnPause" mat-button [disabled]="agentSpeaking || thinking || paused" (click)="pauseInterview()"><mat-icon slot="start">pause</mat-icon> Potřebuji pauzu (začít znovu poslední otázkou)</button>
            </div>
            <div class="switchText">
              <mat-button-toggle-group [matTooltip]="!canUseMic ? 'Mikrofon není dostupný nebo není splněna zkouška mikrofonu.' : undefined" name="switchInput" [(ngModel)]="prefersText" (change)="changeInput()" aria-label="Změnit vstup">
                <mat-button-toggle [matTooltip]="!canUseMic ? undefined : 'Přepnout na diktování'" [disabled]="!canUseMic" [value]="false"><mat-icon>mic</mat-icon></mat-button-toggle>
                <mat-button-toggle [matTooltip]="!canUseMic ? undefined : 'Přepnout na psaní'" [value]="true"><mat-icon>keyboard</mat-icon></mat-button-toggle>
              </mat-button-toggle-group>
            </div><br>
          }
        </div>
      </div>
    </div>
  </div>
}
<div class="countdown spinner-overlay"
     [class.running]="!thinking && !agentSpeaking && !paused && !speechResumed && !prefersText"
     [style.--duration]="'14s'"
     [style.visibility]="!thinking && !agentSpeaking && !paused && !speechResumed && !prefersText ? 'visible' : 'hidden'">
</div>
<audio style="display: none;"></audio>
